import React from "react";
import { colors, font } from "/utils/styles";

export default function NavTitle(props) {
	return (
		<h1 className="title" style={{}}>
			{props.title}

			<style jsx="true">{`
				.title {
					font-weight: regular;
					line-height: 22px;
					font-size: 22px;
					color: ${colors.purple};
					font-family: ${font.Athelas};
				}
			`}</style>
		</h1>
	);
}
